import { timeZone } from 'interfaces/timezone-type';
import { BookingFilterAny } from 'stores/rematch/models/types/booking-filter';
import { SetBookingListPayload } from 'stores/rematch/models/types/bookings-store';
import { TimezoneSelectorMode } from 'utilities/enum-utils';
import { IRosterBooking, IRosterShift } from '../bookings-roster-view/types';
import { ROSTER_TAB } from '../bookings-roster-view/components/roster-common-enums';
import { Updater } from '@tanstack/react-table';

const noop = () => {};
const asyncNoop = async () => Promise.resolve();

export type BookingDrawerContentType = 'customerBooking' | 'openSlot' | 'workerShift';

export type RosterPeriodView = 'daily' | 'weekly';

export type OnSelectRosterItemOptions = {
  item: IRosterBooking | IRosterShift | null;
  type: BookingDrawerContentType | null;
  tab: ROSTER_TAB | null;
};

export type FetchBookingsOptions = {
  allViews?: boolean;
  filters?: BookingFilterAny[];
  initialFetch?: boolean;
  onFailure?: (error: unknown) => Promise<void>;
  onSuccess?: (bookings: SetBookingListPayload) => Promise<void>;
  pageNumber?: number;
  pageTimestamp?: Date;
  reset?: boolean;
  viewId?: string;
  caller?: string;
};

export type BookingsViewContextType = {
  checkAllIndicator: boolean;
  displayTimezone: timeZone | null | undefined;
  fetchBookings: (opts: FetchBookingsOptions) => Promise<void>;
  fetchedViewIds: string[];
  hasError: boolean;
  hasFetchedInitialViews: boolean;
  indeterminateCheck: boolean;
  onChangeCheckAllIndicator: (checkAll: boolean) => void;
  onChangeFilter: (filters: BookingFilterAny[]) => void;
  onChangeIndeterminateCheck: (indeterminate: boolean) => void;
  onChangeRosterPeriod: (period: RosterPeriodView) => void;
  onChangeShowActionSheet: (show: boolean) => void;
  onChangeTimezone: (type: 'mode' | 'customTimezone', value: TimezoneSelectorMode) => void;
  pageNumbers: Record<string, number>;
  pageSize: number;
  pageTimestamps: Record<string, Date>;
  refreshListings: () => void;
  resetViews: (viewIds: string[]) => void;
  retry: () => Promise<void>;
  rosterPeriod: RosterPeriodView;
  showActionSheet: boolean;
  onOpenCreateBooking: (opts?: { customer?: unknown; startDate?: Date }) => void;
  onSelectRosterItem: (next: Updater<OnSelectRosterItemOptions> | OnSelectRosterItemOptions) => void;
  registerRefetchRoster: (refetch: () => Promise<void>) => void;
  selectedRosterItem: IRosterBooking | IRosterShift | null;
  onDeselectRosterItem: () => void;
};

export const bookingsViewContextInitialState: BookingsViewContextType = {
  checkAllIndicator: false,
  displayTimezone: undefined,
  fetchBookings: asyncNoop,
  fetchedViewIds: [],
  hasError: false,
  hasFetchedInitialViews: false,
  indeterminateCheck: false,
  onChangeCheckAllIndicator: noop,
  onChangeFilter: noop,
  onChangeIndeterminateCheck: noop,
  onChangeRosterPeriod: noop,
  onChangeShowActionSheet: noop,
  onChangeTimezone: noop,
  pageNumbers: {},
  pageSize: 20,
  pageTimestamps: {},
  refreshListings: noop,
  resetViews: noop,
  retry: asyncNoop,
  rosterPeriod: 'weekly',
  showActionSheet: false,
  onOpenCreateBooking: noop,
  onSelectRosterItem: noop,
  registerRefetchRoster: noop,
  selectedRosterItem: null,
  onDeselectRosterItem: noop,
};
